import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import type { RelatedContactFormResult } from "./AddRelatedContactForm";

export const convertRelatedContactToContact = (
  { relationship, dateOfBirth, ...contact }: RelatedContactFormResult,
  relatedEnduserId: string
): Partial<TellescopeModelFromName<"endusers">> => {
  return {
    ...contact,
    relationships: [{ type: relationship, id: relatedEnduserId }],
    dateOfBirth: dateOfBirth?.toISOString(),
  };
};
